import {DataUpload} from "../../DataUpload/DataUpload";

// Д1 — раздел „Данни". Операциите с данни (качване / преглед-редакция /
// изтриване по година+землище) вече ги има изцяло в DataUpload, затова тук го
// преизползваме без промяна — гарантира „нула видима промяна" на /data-upload и
// нула нов код по същество (§3).
//
// Отклонение от дизайна (§3 предлагаше разцепване на DataUpload на три секции):
// пълният реюз е по-безопасен от рефакторирането на голям работещ компонент
// (правилото за ескалация в WORK_PLAN). Резултатът за потребителя е същият.
//
// Копирането остава per-ползвател на страницата на ползвателя (таб „Копиране") —
// нов bulk механизъм НЕ се прави (извън одобрения обхват).
export const AdminData = () => {
    return (
        <div>
            <h3 className="mb-3">Данни</h3>
            <p className="text-muted">
                Качване на изходни данни, преглед и редакция, изтриване по година и
                землище. Копирането от предходна година остава на страницата на
                съответния ползвател (таб „Копиране").
            </p>
            <DataUpload/>
        </div>
    );
};
